import * as Yup from "yup";
import { fuelsCodes } from "../../../../utils/dataAndFormulas/fuelsForms";

export function initialValues(form, period, year,unitsRecorded) {
  return {
    date: form?.date || "",
    creator_user: form?.creator_user || "",
    state: form?.state || "",
    period: form?.period || period,
    year: form?.year || year,
      natural_gas: form?.natural_gas || {
        code: fuelsCodes["natural_gas"],
        unit: unitsRecorded?.["natural_gas"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      natural_gas_cost: form?.natural_gas_cost || {
        code: fuelsCodes["natural_gas_cost"],
        unit: unitsRecorded?.["natural_gas_cost"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      glp: form?.glp || {
        code: fuelsCodes["glp"],
        unit: unitsRecorded?.["glp"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      glp_cost: form?.glp_cost || {
        code: fuelsCodes["glp_cost"],
        unit: unitsRecorded?.["glp_cost"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      // heavy_fuel_oil: form?.heavy_fuel_oil || {
      //   code: fuelsCodes["heavy_fuel_oil"],
      //   unit: unitsRecorded?.["heavy_fuel_oil"] || "",
      //   value: 0,
      //   reviews: [],
      //   approvalStatus: "pending",
      //   files:[],
      // },
      // cost_heavy_fuel_oil: form?.cost_heavy_fuel_oil || {
      //   code: fuelsCodes["cost_heavy_fuel_oil"],
      //   unit: unitsRecorded?.["cost_heavy_fuel_oil"] || "",
      //   value: 0,
      //   reviews: [],
      //   approvalStatus: "pending",
      //   files:[],
      // },
      // light_fuel_oil: form?.light_fuel_oil || {
      //   code: fuelsCodes["light_fuel_oil"],
      //   unit: unitsRecorded?.["light_fuel_oil"] || "",
      //   value: 0,
      //   reviews: [],
      //   approvalStatus: "pending",
      //   files:[],
      // },
      // cost_light_fuel_oil: form?.cost_light_fuel_oil || {
      //   code: fuelsCodes["cost_light_fuel_oil"],
      //   unit: unitsRecorded?.["cost_light_fuel_oil"] || "",
      //   value: 0,
      //   reviews: [],
      //   approvalStatus: "pending",
      //   files:[],
      // },
      diesel: form?.diesel || {
        code: fuelsCodes["diesel"],
        unit: unitsRecorded?.["diesel"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      diesel_cost: form?.diesel_cost || {
        code: fuelsCodes["diesel_cost"],
        unit: unitsRecorded?.["diesel_cost"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      // gasoline_internal_vehicles:
      //   form?.gasoline_internal_vehicles || {
      //     code: fuelsCodes["gasoline_internal_vehicles"],
      //     unit: unitsRecorded?.["gasoline_internal_vehicles"] || "",
      //     value: 0,
      //     reviews: [],
      //     approvalStatus: "pending",
      //     files:[],
      //   },
      // gasoline_cost_internal_vehicles:
      //   form?.gasoline_cost_internal_vehicles || {
      //     code: fuelsCodes[
      //       "gasoline_cost_internal_vehicles"
      //     ],
      //     unit: unitsRecorded?.["gasoline_cost_internal_vehicles"] || "",
      //     value: 0,
      //     reviews: [],
      //     approvalStatus: "pending",
      //     files:[],
      //   },
      biodiesel: form?.biodiesel || {
        code: fuelsCodes["biodiesel"],
        unit: unitsRecorded?.["biodiesel"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      cost_biodiesel: form?.cost_biodiesel || {
        code: fuelsCodes["cost_biodiesel"],
        unit: unitsRecorded?.["cost_biodiesel"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      gasoline: form?.gasoline || {
        code: fuelsCodes["gasoline"],
        unit: unitsRecorded?.["gasoline"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      gasoline_cost: form?.gasoline_cost || {
        code: fuelsCodes["gasoline_cost"],
        unit: unitsRecorded?.["gasoline_cost"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      ethanol: form?.ethanol || {
        code: fuelsCodes["ethanol"],
        unit: unitsRecorded?.["ethanol"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      ethanol_cost: form?.ethanol_cost || {
        code: fuelsCodes["ethanol_cost"],
        unit: unitsRecorded?.["ethanol_cost"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      electricity_vehicles: form?.electricity_vehicles || {
        code: fuelsCodes["electricity_vehicles"],
        unit: unitsRecorded?.["electricity_vehicles"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      cost_electricity_vehicles: form?.cost_electricity_vehicles || {
        code: fuelsCodes["cost_electricity_vehicles"],
        unit: unitsRecorded?.["cost_electricity_vehicles"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },

      natural_gas_vehicles: form?.natural_gas_vehicles || {
        code: fuelsCodes["natural_gas_vehicles"],
        unit: unitsRecorded?.["natural_gas_vehicles"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      glp_vehicles: form?.glp_vehicles || {
        code: fuelsCodes["glp_vehicles"],
        unit: unitsRecorded?.["glp_vehicles"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      diesel_vehicles: form?.diesel_vehicles || {
        code: fuelsCodes["diesel_vehicles"],
        unit: unitsRecorded?.["diesel_vehicles"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      biodiesel_vehicles: form?.biodiesel_vehicles || {
        code: fuelsCodes["biodiesel_vehicles"],
        unit: unitsRecorded?.["biodiesel_vehicles"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      gasoline_vehicles: form?.gasoline_vehicles || {
        code: fuelsCodes["gasoline_vehicles"],
        unit: unitsRecorded?.["gasoline_vehicles"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      ethanol_vehicles: form?.ethanol_vehicles || {
        code: fuelsCodes["ethanol_vehicles"],
        unit: unitsRecorded?.["ethanol_vehicles"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
      electric_vehicles: form?.electric_vehicles || {
        code: fuelsCodes["electric_vehicles"],
        unit: unitsRecorded?.["electric_vehicles"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files:[],
      },
  };
}

export function validationSchema() {
    const schemaFields = {
      period: Yup.string("Dato requerido").required(
        "El campo periodo es obligatorio"
      ),
    };
  
    // Generar esquema para cada código de energía
    Object.keys(fuelsCodes).forEach((key) => {
      schemaFields[key] = Yup.object({
        value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
        unit: Yup.string().when("value", {
          is: (val) => val !== 0 && val !== null && val !== "",
          then: (schema) => schema.required("Debe completar la unidad"),
          otherwise: (schema) => schema.notRequired(),
        }),
      });
    });
  
    return Yup.object(schemaFields);
}
